var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5789 21.7346C45.244 21.7346 42.3197 25.0468 40.0001 27.3437C37.6805 25.0468 34.7562 21.7346 29.4213 21.7346C24.0863 21.7346 18.5681 26.7684 18.8429 33.9594C18.8429 44.1708 32.6765 53.1595 40.0001 58.2653C47.3237 53.1595 61.1573 44.1708 61.1573 33.9594C61.4321 26.7684 55.9138 21.7346 50.5789 21.7346Z",
    fill: "url(#paint0_radial_31265_3505)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_31265_3505",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.1365 21.7346) rotate(127.736) scale(46.1925 55.4007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330493,
    stopColor: "#CAC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333117,
    stopColor: "#BAB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630108,
    stopColor: "#BBB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#9E9CFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.5dc4f8c5eb326cc74e03061547e8796e.svg";
export { ForwardRef as ReactComponent };